import { render } from "./FavoriteList.vue?vue&type=template&id=c63ac40c&scoped=true&ts=true"
import script from "./FavoriteList.vue?vue&type=script&lang=ts"
export * from "./FavoriteList.vue?vue&type=script&lang=ts"

import "./FavoriteList.vue?vue&type=style&index=0&id=c63ac40c&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c63ac40c"]])

export default __exports__